module.exports = __webpack_public_path__ + "static/img/4.ba09a39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/4.png
// module id = 8it3
// module chunks = 0